import { asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime, objectSpread2 as _objectSpread2, toConsumableArray as _toConsumableArray } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import { createSelector } from 'reselect';
import { v4 } from 'uuid';
import { LayoutType } from '../../../types/layouts.esm.js';
import { getSelectedLayout } from '../../../utilities/get-selected-layout.esm.js';
import { getLayoutById } from '../../../utilities/get-layout-by-id.esm.js';
import { sortLayouts } from '../../../utilities/sort-layouts.esm.js';
import { trim } from '../../../utilities/trim.esm.js';
import { same } from '../../../utilities/same.esm.js';
import { getCommands } from '../../../utilities/get-commands.esm.js';
import { getLayoutByName } from '../../../utilities/get-layout-by-name.esm.js';

var changeCustomLayout = function changeCustomLayout(layouts, newLayout) {
  var newLayouts = layouts.filter(function (l) {
    return l.type !== LayoutType.Custom;
  }).filter(function (x) {
    return !same(x.label, newLayout.label);
  });
  return sortLayouts([].concat(_toConsumableArray(newLayouts), [newLayout]));
};
var changeSavedLayout = function changeSavedLayout(layouts, layoutToUpdate, newLayout) {
  var newLayouts = layouts.map(function (l) {
    return l.id === layoutToUpdate.id ? layoutToUpdate : l;
  }).filter(function (x) {
    return !same(x.label, newLayout.label);
  });
  return sortLayouts([].concat(_toConsumableArray(newLayouts), [newLayout]));
};
function getSaveAsCallback(layouts, onChange, displayLayouts, setDisplayLayouts, onSaveLayout, onDeleteLayout) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(label) {
      var currentLayout, customLayoutToDelete, previousLayoutWithSameName, selected, layoutToCreateInDatabase, layoutToCreateToShowInUI, newLayouts, newDisplayLayouts, layoutToUpdate, _previousLayoutWithSameName, layoutToCreateSelected, layoutToCreate, _newLayouts, _newDisplayLayouts;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            currentLayout = getSelectedLayout(displayLayouts);
            _context.t0 = currentLayout.type;
            _context.next = _context.t0 === LayoutType.Default ? 4 : _context.t0 === LayoutType.Predefined ? 5 : _context.t0 === LayoutType.Custom ? 6 : _context.t0 === LayoutType.Saved ? 16 : 25;
            break;
          case 4:
            throw new Error('You cannot use the "save as" function for the default layout.');
          case 5:
            throw new Error('You cannot use the "save as" function for the predefined layout.');
          case 6:
            customLayoutToDelete = layouts.find(function (l) {
              return l.type === LayoutType.Custom;
            });
            previousLayoutWithSameName = getLayoutByName(layouts, label);
            selected = (previousLayoutWithSameName === null || previousLayoutWithSameName === void 0 ? void 0 : previousLayoutWithSameName.selected) || (customLayoutToDelete === null || customLayoutToDelete === void 0 ? void 0 : customLayoutToDelete.selected) || false;
            layoutToCreateInDatabase = _objectSpread2(_objectSpread2({}, currentLayout), {}, {
              type: LayoutType.Saved,
              selected: selected,
              id: (previousLayoutWithSameName === null || previousLayoutWithSameName === void 0 ? void 0 : previousLayoutWithSameName.id) || v4(),
              label: trim(label)
            });
            layoutToCreateToShowInUI = _objectSpread2(_objectSpread2({}, layoutToCreateInDatabase), {}, {
              selected: true
            });
            newLayouts = changeCustomLayout(layouts, layoutToCreateInDatabase);
            onChange(newLayouts);
            newDisplayLayouts = changeCustomLayout(displayLayouts, layoutToCreateToShowInUI);
            setDisplayLayouts(newDisplayLayouts);
            return _context.abrupt("return", getCommands({
              onSaveLayout: onSaveLayout,
              onDeleteLayout: onDeleteLayout
            })(layouts, newLayouts));
          case 16:
            layoutToUpdate = getLayoutById(layouts, currentLayout.id);
            _previousLayoutWithSameName = getLayoutByName(layouts, label);
            layoutToCreateSelected = (_previousLayoutWithSameName === null || _previousLayoutWithSameName === void 0 ? void 0 : _previousLayoutWithSameName.selected) || (layoutToUpdate === null || layoutToUpdate === void 0 ? void 0 : layoutToUpdate.selected) || false;
            layoutToCreate = _objectSpread2(_objectSpread2({}, currentLayout), {}, {
              selected: layoutToCreateSelected,
              id: (_previousLayoutWithSameName === null || _previousLayoutWithSameName === void 0 ? void 0 : _previousLayoutWithSameName.id) || v4(),
              label: trim(label)
            });
            _newLayouts = changeSavedLayout(layouts, _objectSpread2(_objectSpread2({}, layoutToUpdate), {}, {
              selected: layoutToCreateSelected ? false : layoutToUpdate.selected
            }), layoutToCreate);
            onChange(_newLayouts);
            _newDisplayLayouts = changeSavedLayout(displayLayouts.map(function (l) {
              return _objectSpread2(_objectSpread2({}, l), {}, {
                selected: false
              });
            }), _objectSpread2(_objectSpread2({}, layoutToUpdate), {}, {
              selected: false
            }), _objectSpread2(_objectSpread2({}, layoutToCreate), {}, {
              selected: true
            }));
            setDisplayLayouts(_newDisplayLayouts);
            return _context.abrupt("return", getCommands({
              onSaveLayout: onSaveLayout,
              onDeleteLayout: onDeleteLayout
            })(layouts, _newLayouts));
          case 25:
            throw new Error('Unknown type.');
          case 26:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}
var createSaveAsCallbackSelector = function createSaveAsCallbackSelector() {
  return createSelector(function (props) {
    return props.layouts;
  }, function (props) {
    return props.onChange;
  }, function (props) {
    return props.displayLayouts;
  }, function (props) {
    return props.setDisplayLayouts;
  }, function (props) {
    return props.onSaveLayout;
  }, function (props) {
    return props.onDeleteLayout;
  }, getSaveAsCallback);
};

export { createSaveAsCallbackSelector, getSaveAsCallback };
//# sourceMappingURL=save-as-callback-selector.esm.js.map
